
import React, { Component, useEffect, useState } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
import ReactDOM from 'react-dom';

import styles from './Home.module.css';
import zuzLogo from '../../assets/images/zuz-logo-filled-text.png';
import zuzLogoFilledNo from '../../assets/images/zuz-logo-filled-no.png';
import theme1net from '../../assets/images/theme1net.png';
import theme2net from '../../assets/images/theme2net.png';
import pyramid from '../../assets/images/pyramid.png';
import funnel from '../../assets/images/geyser-glow.png';
import Ethereum from '../../assets/images/ethereum.png';
import MetaMask from '../../assets/images/meta-mask.png';
import netOverlay from '../../assets/images/theme3net.png';
import zoomedNet from '../../assets/images/zoomedNet.PNG';
import mobileZoomedNet from '../../assets/images/mobileZoomedNet.PNG';

import ChainCircle, { RightArrow, RefreshLogo, EthereumIcon, DotsBox, TwitterIcon, YoutubeIcon, ArrowFly, RightKeyboardArrow, Tick, ArrowUp, MoreHoriz } from '../Svg/index';
import Sil01 from '../Svg/Sil01';
import Sil02 from '../Svg/Sil02';
import Sil03 from '../Svg/Sil03';
import Sil04 from '../Svg/Sil04';
import Sil05 from '../Svg/Sil05';
import Sil06 from '../Svg/Sil06';
import Sil07 from '../Svg/Sil07';
import Sil08 from '../Svg/Sil08';


import zuzVideo from '../../assets/media/zuz-website-animation.mp4';


import Desktop, { Tablet, Mobile } from '../MediaQueries';

import MyChart from '../Charts/index';
import ScrollAnimation from 'react-animate-on-scroll';
import { motion, useAnimation } from "framer-motion";
import { useInView } from 'react-intersection-observer';

export class Home extends Component {
    render() {
        return (
            <Router>
                <div className={styles.homePage}>
                    <div className={styles.heroScreenSection}>
                        <div className={styles.toggleMoreHoz}>
                            <MoreHoriz></MoreHoriz>
                        </div>
                        <div className={styles.containerWithImageBack}>
                            <header className={styles.header}>
                                <div className={styles.zuzLogo}>
                                    <img src={zuzLogo} alt="zuz logo" />
                                </div>
                                <div className={styles.navigationLinks}>
                                    <ul>
                                        <li>
                                            <Link to="/">WHITEPAPER</Link>
                                        </li>
                                        <li>
                                            <Link to="/viewTokenStats">VIEW TOKEN STATS</Link>
                                        </li>
                                        <li>
                                            <Link to="/signIn">SIGN IN</Link>
                                        </li>
                                    </ul>
                                </div>
                            </header>
                            <div className={styles.headerH1Description}>
                                <div className={styles.leftHeaderH1Description}>
                                    <div>
                                        <h1>
                                            ZUZ - for anyone and everyone
                                        </h1>
                                    </div>
                                    <Mobile>
                                        <video width="100%" height="auto" controls={true}>
                                            <source src={zuzVideo} type="video/mp4" />
                                        </video>
                                    </Mobile>
                                    <Tablet>
                                        <video width="100%" height="auto" controls={true}>
                                            <source src={zuzVideo} type="video/mp4" />
                                        </video>
                                    </Tablet>
                                    <div className={styles.description}>
                                        <p>
                                            ZUZ Finance is an open for all ecosystem aimed to bring crypto to the masses in a simple and straightforward way.
                                        </p>
                                    </div>
                                    <div className={styles.description}>
                                        <p>
                                            ZUZ is a social token growing in value and circulating supply by and for its global community
                                        </p>
                                    </div>
                                </div>
                                <div className={styles.rightHeaderH1Description}>
                                    <div className={styles.dots}>
                                        <DotsBox></DotsBox>
                                    </div>
                                    <div className={styles.joinUsBtnCont}>
                                        <div className={styles.joinUsBtn}>
                                            <div className={styles.arrowCont}>
                                                <RightArrow></RightArrow>
                                            </div>
                                            <div className={styles.joinNowPara}>
                                                <p>JOIN NOW</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <IntroductionSection>
                    </IntroductionSection>

                    <HowDoIJoinSection>
                    </HowDoIJoinSection>


                    <EthPiChart></EthPiChart>

                    <Mobile>
                        <video width="100%" height="auto" controls={true}>
                            <source src={zuzVideo} type="video/mp4" />
                        </video>
                    </Mobile>
                    <Tablet>
                        <video width="100%" height="auto" controls={true}>
                            <source src={zuzVideo} type="video/mp4" />
                        </video>
                    </Tablet>

                    <FooterSection></FooterSection>
                </div >
            </Router>
        )
    }
}



const FooterSection = () => {
    const { ref, inView, entry } = useInView({ trackVisibility: true, delay: 100 });


    return (
        <motion.div
            className={styles.footerSection}
            ref={ref}
        >
            <div className={styles.bgOverlay}>
                <div className={styles.circle} style={{ left: '-300px' }}>

                </div>
                <div className={styles.circle} style={{ left: 'calc((100% - 420px) / 2)' }}>
                    <motion.div
                        className={styles.joinZuzComm}
                        layout
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={
                            inView ?
                                { opacity: 1, scale: 1 } :
                                { opacity: 0, scale: 0.8 }
                        }
                        transition={{ duration: 1, delay: 1 }}
                    >
                        <h3>JOIN THE ZUZ COMMUNITY TODAY!</h3>
                    </motion.div>
                    <img src={zuzLogoFilledNo} />
                </div>
                <div className={styles.circle} style={{ right: '-300px' }}>

                </div>
                <motion.div
                    className={styles.joinUsInFooter}
                    layout
                    initial={{ opacity: 0 }}
                    animate={
                        inView ?
                            { opacity: 1 } :
                            { opacity: 0 }
                    }
                    transition={{ duration: 1, delay: 2 }}
                >
                    <JoinUsButton></JoinUsButton>
                </motion.div>
            </div>
            <motion.div
                className={styles.footerH1}
                layout
                initial={{ opacity: 0, y: -100 }}
                animate={
                    inView ?
                        { opacity: 1, y: 0 } :
                        { opacity: 0, y: -100 }
                }
                transition={{ duration: 1, delay: 0 }}
            >
                <div className={styles.left}>
                    <a href="" className={styles.backToVideoBtn}>
                        <span>
                            <ArrowUp></ArrowUp>
                        </span>
                        BACK TO VIDEO
                    </a>
                </div>
                <div className={styles.right}>
                    <a href="">
                        VIEW TOKEN STATS
                    </a>
                    <a href="">
                        WHITE PAPERS
                    </a>
                </div>
            </motion.div>
            <motion.div
                className={styles.footerH2}
                layout
                initial={{ opacity: 0, y: 100 }}
                animate={
                    inView ?
                        { opacity: 1, y: 0 } :
                        { opacity: 0, y: 100 }
                }
                transition={{ duration: 1, delay: 0 }}
            >

                <a href="">
                    <span className={styles.icon}>
                        <TwitterIcon></TwitterIcon>
                    </span>
                    <span className={styles.iconText}>
                        Twitter
                </span>
                </a>
                <a href="">
                    <span className={styles.icon}>
                        <ArrowFly></ArrowFly>
                    </span>
                    <span className={styles.iconText}>
                        Telegram group
                    </span>
                </a>
                <a href="">
                    <span className={styles.icon}>
                        <ArrowFly></ArrowFly>
                    </span>
                    <span className={styles.iconText}>
                        Announcements
                </span>
                </a>
                <a href="">
                    <span className={styles.icon}>
                        <YoutubeIcon></YoutubeIcon>
                    </span>
                    <span className={styles.iconText}>
                        Youtube
                </span>
                </a>

            </motion.div>


            <div className={styles.zuzFinanceComp}>
                <p>(C) ZUZ FINANCE COMPANY</p>
            </div>
        </motion.div>
    )
}



const EthPiChart = () => {

    const { ref, inView, entry } = useInView({ trackVisibility: true, delay: 100 });


    return (
        <motion.div
            className={styles.ethereumPiChart}
            layout
            initial={{ opacity: 0, scale: 0.8 }}
            animate={
                inView ?
                    { opacity: 1, scale: 1 } :
                    { opacity: 0, scale: 0.8 }
            }
            transition={{ duration: 1, delay: 0 }}
            ref={ref}
        >
            <div className={styles.divisionOfEthereum}>
                <span className={styles.hSpan}></span>
                <p>The extra ETH will be split and used in the following way:</p>
            </div>
            <div className={styles.statsContainer}>
                <div className={styles.statsTop}>

                </div>
                <div className={styles.statsMiddle}>
                    <div className={styles.leftWing}>
                        <div className={styles.leftWingMirror}>

                        </div>
                        <h3>30%</h3>
                        <p> Will be used to buy ZUZ tokens and burn them.</p>
                        <p>This is a deflationary measure meant to preserve the ZUZ token value.</p>
                    </div>
                    <div className={styles.piChart}>
                        <div className={styles.innerPiChart}>
                            <MyChart></MyChart>
                        </div>
                    </div>
                    <div className={styles.rightWing}>
                        <div className={styles.rightWingMirror}>

                        </div>
                        <h3>30%</h3>
                        <p>Will be used to buy ZUZ tokens and airdrop them to the top 100 ZUZ holders, and a random number of random ZUZ holders.</p>
                        <p>This will be done as a percentage of holdings as a way to motivate and reward ZUZ members.</p>
                    </div>
                </div>
                <div className={styles.statsBottom}>
                    <div className={styles.statsBottomWing}></div>
                    <h3>40%</h3>
                    <p>Will be used for ZUZ marketing and operations</p>
                </div>
            </div>
        </motion.div>
    )
}





function JoinUsButton(props) {
    return (

        <div className={styles.joinUsBtn}>
            <div className={styles.arrowCont}>
                <RightArrow></RightArrow>
            </div>
            <div className={styles.joinNowPara}>
                <p>JOIN NOW</p>
            </div>
        </div>
    )
}



function NetOverlayWithFunnel(props) {

    const { ref, inView, entry } = useInView({ trackVisibility: true, delay: 100 });
    const [fInView, setFInView] = useState(inView);

    useEffect(() => {

        setFInView(inView);

    }, [inView])


    return (
        <div className={styles.netOverlayWithFunnel}
            ref={ref}>

            <style>{`
                @keyframes commAnim { 
                    0%   {
                        opacity: 0;
                        transform: translateY(-70px);
                    }
            
                
                    100% {
                        opacity: 1;
                        transform: translateY(0px);
                    }
                }
            `}</style>
            <div
                className={`${styles.netOverlay} ${fInView ? styles.netOverlayAnimClass : ''}`}
                style={props.style}>

                <img
                    src={netOverlay}
                    className={`${styles.netOverlayImg} ${fInView ? styles.netOverlayImgAnimClass : ''}`}
                />

                <div
                    className={`${styles.pyramid} ${fInView ? styles.pyramidAnimClass : ''}`}
                >
                    <img src={pyramid} className={styles.pyramidImg} />
                    {
                        <div className={styles.funnel}>
                            <img src={funnel} className={styles.funnelImg} />
                            <div className={styles.funnelCap}>

                            </div>
                        </div>
                    }




                    {
                        <div className={styles.funnel2}>
                            <img src={funnel} className={styles.funnelImg2} />
                            <div className={styles.funnelCap2}>

                            </div>
                        </div>
                    }





                    <div className={styles.ethLogoInGeyser}>
                        <EthereumIcon></EthereumIcon>
                    </div>
                    <div className={styles.energyLogoInGeyser}>
                        <EthereumIcon></EthereumIcon>
                    </div>

                    <div className={styles.refreshWithStatement}>
                        <RefreshLogo></RefreshLogo>
                        <p>
                            ZUZ GEYSER
                        </p>
                    </div>






                    <div className={styles.hSetOfArrows}>
                        <span>
                            <RightArrow></RightArrow>
                        </span>
                        <span>
                            <RightArrow></RightArrow>
                        </span>
                        <span>
                            <RightArrow></RightArrow>
                        </span>
                    </div>


                    <div className={styles.vSetOfArrows}>
                        <span>
                            <RightArrow></RightArrow>
                        </span>
                        <span>
                            <RightArrow></RightArrow>
                        </span>
                        <span>
                            <RightArrow></RightArrow>
                        </span>
                    </div>

                    <div
                        className={`${styles.ethPool} ${fInView ? styles.ethPoolAnimClass : ''}`}
                    >
                        <div className={styles.ethImage}>
                            <EthereumIcon></EthereumIcon>
                        </div>
                        <div className={styles.ethPoolSt}>
                            <p>ETH POOL</p>
                        </div>
                        <div className={styles.ethArrowImage}>
                            <RightKeyboardArrow></RightKeyboardArrow>
                        </div>
                    </div>


                    <EthPoolValueInc
                        inView={fInView}
                    >
                    </EthPoolValueInc>
                </div>






                <div
                    className={`${styles.referralPeople} ${fInView ? styles.referralPeopleAnimClass : ''}`}
                >
                    <div
                        className={`${styles.sil01} ${fInView ? styles.sil01AnimClass : ''}`}
                    >
                        <Sil04></Sil04>
                    </div>
                    <div
                        className={`${styles.sil02} ${fInView ? styles.sil02AnimClass : ''}`}
                    >
                        <Sil07></Sil07>
                    </div>
                    <div
                        className={`${styles.sil03} ${fInView ? styles.sil03AnimClass : ''}`}
                    >
                        <Sil06></Sil06>
                    </div>
                    <div
                        className={`${styles.sil04} ${fInView ? styles.sil04AnimClass : ''}`}
                        style={{ transform: 'rotateY(180deg) !important' }}
                    >
                        <Sil05></Sil05>
                    </div>
                    <div
                        className={`${styles.sil05} ${fInView ? styles.sil05AnimClass : ''}`}
                    >
                        <Sil08></Sil08>
                    </div>

                    <motion.div
                        className={styles.sil06}

                    >
                        <Sil01></Sil01>
                    </motion.div>

                    <motion.div
                        className={styles.referralsPara}
                        style={{ animation: props.inView ? `commAnim 1s 1s` : 'none' }}
                    >
                        <p>REFERRALS</p>
                    </motion.div>
                    <div className={styles.youPara}>
                        <motion.p
                            style={{ animation: props.inView ? `commAnim 1s 0s` : 'none' }}
                        >
                            YOU
                        </motion.p>
                        <span
                            className={`${styles.tickIconSpan} ${fInView ? styles.tickAnimClass : ''}`}
                        >
                            <Tick></Tick>
                        </span>
                    </div>
                </div>
            </div>
            <ThreePeopleBox fInView={fInView}>
            </ThreePeopleBox>
        </div>
    )
}



const EthPoolValueInc = (props) => {


    const [values, setValues] = useState([1, 1, 1, 1, 1]);
    return (

        <div
            className={`${props.inView ? styles.ethPoolValueIncClassAnim : ''}`}
        >
            <style>{`
            
@keyframes ethValueIncAnim { 
    0%   {
        opacity: 0;
        transform: translateY(-70px);
    }

    
    50% {
        opacity: 1;
        transform: translateY(30px);
    }

    100% {
        opacity: 1;
        transform: translateY(0px);
    }
}
            
            `}</style>
            {
                values.map((value, index) => (
                    <div
                        className={styles.ethPoolValueInc}
                        style={{ animation: props.inView ? `ethValueIncAnim 1s ${1 * (index + 1)}` : 'none' }}
                    >
                        <div className={styles.ethImage}>
                            <EthereumIcon></EthereumIcon>
                        </div>
                        <div className={styles.ethValue}>
                            <p>+0.05 ETH</p>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}









function IntroductionSection() {

    const { ref, inView, entry } = useInView({ trackVisibility: true, delay: 100 });

    return (
        <motion.div
            className={styles.introductionSection}
            ref={ref}
        >

            <motion.div
                layout
                initial={{ opacity: 0, scale: 0.3 }}
                animate={
                    inView ?
                        { opacity: 1, scale: 1 } :
                        { opacity: 0, scale: 0.3 }
                }
                transition={{ duration: 3, delay: 0 }}
                style={{
                    width: '100%',
                    height: 'auto'
                }}
            >
                <ChainCircle></ChainCircle>
            </motion.div>

            <div className={styles.introductionStatementsBlock}>
                <motion.div
                    className={styles.introSt1}
                    layout
                    initial={{ opacity: 0, scale: 0.3 }}
                    animate={
                        inView ?
                            { opacity: 1, scale: 1 } :
                            { opacity: 0, scale: 0.3 }
                    }
                    transition={{ duration: 1, delay: 0 }}
                >
                    <p>
                        ZUZ finance is a community driven project.
                    </p>
                </motion.div>
                <motion.div
                    className={styles.introSt2}
                    layout
                    initial={{ opacity: 0, scale: 0.3 }}
                    animate={
                        inView ?
                            { opacity: 1, scale: 1 } :
                            { opacity: 0, scale: 0.3 }
                    }
                    transition={{ duration: 1, delay: 0.5 }}
                >
                    <p>
                        Driving it is the concept that any person in the world
                        can join and earn tokens based on their efforts and
                        contribution to the growth of the ZUZ ecosystem.
                    </p>
                </motion.div>
                <motion.div
                    className={styles.introSt3}
                    layout
                    initial={{ opacity: 0, scale: 0.3 }}
                    animate={
                        inView ?
                            { opacity: 1, scale: 1 } :
                            { opacity: 0, scale: 0.3 }
                    }
                    transition={{ duration: 1, delay: 1 }}
                >
                    <p>
                        In order to allow ZUZ to grow with no supply limits on
                        one hand, while protecting the token holders’ ZUZ value, we’ve created our special mechanism named DRIM.
                    </p>
                </motion.div>
                <motion.div
                    className={styles.introSt4}
                    layout
                    initial={{ opacity: 0, scale: 0.3 }}
                    animate={
                        inView ?
                            { opacity: 1, scale: 1 } :
                            { opacity: 0, scale: 0.3 }
                    }
                    transition={{ duration: 1, delay: 1.5 }}
                >
                    <p>
                        DRIM stands for Decentralized Relative Inflationary Mechanism
                        and is our unique inflationary mechanism making sure
                        that active ZUZ members are being rewarded.
                    </p>
                </motion.div>
            </div>

        </motion.div>
    )
}








function HowDoIJoinSection() {

    return (
        <div
            className={styles.howDoIJoinSection}
        >
            <HowDoIJoinSection1></HowDoIJoinSection1>
            <HowDoIJoinSection2></HowDoIJoinSection2>
            {
                /*
                            <HowDoIJoinSection3></HowDoIJoinSection3>
            <HowDoIJoinSection4></HowDoIJoinSection4>
                */
            }

        </div>
    )
}








function HowDoIJoinSection1() {


    const { ref, inView, entry } = useInView({ trackVisibility: true, delay: 100 });

    return (

        <motion.div
            className={styles.howDoIJoinSection1}
            ref={ref}
        >
            <motion.div
                className={styles.howDoIJoin1Heading}
                layout
                initial={{ opacity: 0 }}
                animate={
                    inView ?
                        { opacity: 1 } :
                        { opacity: 0 }
                }
                transition={{ duration: 1, delay: 0 }}
            >
                <div className={styles.dots}>
                    <DotsBox></DotsBox>
                </div>
                <h2>
                    HOW DO I JOIN?
                </h2>
            </motion.div>

            <div className={styles.howDoIJoin1StatementBlock}>
                <div className={styles.dots}>
                    <DotsBox></DotsBox>
                </div>
                <motion.div
                    className={styles.howDoIJoin1St1}
                    layout
                    initial={{ opacity: 0, y: 50 }}
                    animate={
                        inView ?
                            { opacity: 1, y: 0 } :
                            { opacity: 0, y: 50 }
                    }
                    transition={{ duration: 2, delay: 0 }}
                    style={{ top: 0 }}
                >
                    <motion.div
                        className={styles.logosBox}
                        layout
                        initial={{ opacity: 0, y: 50 }}
                        animate={
                            inView ?
                                { opacity: 1, y: 0 } :
                                { opacity: 0, y: 50 }
                        }
                        transition={{ duration: 2, delay: 1 }}
                    >
                        <div className={styles.ethereumLogo}>
                            <div className={styles.realIcon}>
                                <EthereumIcon></EthereumIcon>
                            </div>

                            <span>
                                ETHEREUM
                        </span>
                        </div>
                        <div className={styles.plusLogo}>
                            <span>+</span>
                        </div>
                        <div className={styles.metaMaskLogo}>
                            <div className={styles.realIcon}>
                                <img src={MetaMask} />
                            </div>

                            <span>
                                METAMASK
                            </span>
                        </div>
                    </motion.div>
                    <span className={styles.hSpan}></span>
                    <h3>01</h3>
                    <p>
                        Register your Ethereum address using Metamask.
                </p>
                    <p>
                        The contract will cost <span style={{ color: '#2DDBF4' }}>0.05 ETH</span> + the gas required
                for a transaction.
                </p>
                </motion.div>

                <motion.div
                    className={styles.howDoIJoin1St2}
                    layout
                    initial={{ opacity: 0, y: 50 }}
                    animate={
                        inView ?
                            { opacity: 1, y: 0 } :
                            { opacity: 0, y: 50 }
                    }
                    transition={{ duration: 1, delay: 1 }}
                    style={{ top: '280px' }}
                >
                    <p>
                        The fee is going to the ZUZ Geyser.
                </p>
                    <p>
                        The ZUZ Geyser is the main address where ZUZ
                        tokens are dist.
                </p>
                </motion.div>

            </div>
        </motion.div>
    )
}










function HowDoIJoinSection2() {
    const { ref, inView, entry } = useInView({ trackVisibility: true, delay: 100 });
    const [fInView, setFInView] = useState(false);

    useEffect(() => {

        setFInView(inView);

    }, [inView]);


    return (
        <div
            className={styles.howDoIJoinSection2}
            ref={ref}
        >



            <NetOverlayWithFunnel
                theme="first"
            ></NetOverlayWithFunnel>

            <div
                className={`${styles.howDoIJoin1St2} ${fInView ? styles.st2AnimClass : ''}`}
            >
                <span className={styles.hSpan}></span>
                <h3>02</h3>
                <p>
                    In order to become a Verified member you will
                            need to <span style={{ color: '#2DDBF4' }}>refer 5</span> people
                            to register their addresses in the ZUZ network.
                        </p>
            </div>




            <div
                className={`${styles.feesCollected} ${fInView ? styles.feesCollectedAnimClass : ''}`}
            >
                <span className={styles.hSpan}></span>
                <p></p>
                <p>The Fees collected in the ZUZ Geyser will be used
                    for Gas for the 3 ZUZ transactions that are sent whenever a member gets verified.</p>
            </div>




            <motion.div
                className={`${styles.howDoIJoin1St3} ${fInView ? styles.st3AnimClass : ''}`}
            >
                <span className={styles.hSpan}></span>
                <h3>03</h3>
                <p>
                    In order to become a Verified member you will
                    need to refer 5 people
                    to register their addresses in the ZUZ network.
                </p>
            </motion.div>



        </div>
    )
}









function HowDoIJoinSection3() {
    return (
        <div
            className={styles.howDoIJoinSection3}
        >
            <div className={styles.upperSpace}>
            </div>
            <NetOverlayWithFunnel
                theme="second"
            >
            </NetOverlayWithFunnel>
        </div>
    )
}







function HowDoIJoinSection4() {
    const { ref, inView, entry } = useInView({ trackVisibility: true, delay: 100 });

    const [fInView, setFInView] = useState(false);

    useEffect(() => {
        if (inView) {
            setFInView(true);
        }
    }, [inView])


    return (
        <motion.div
            className={styles.howDoIJoinSection4}
            ref={ref}
            layout
            initial={{ opacity: 0 }}
            animate={
                fInView ?
                    { opacity: 1 } :
                    { opacity: 0 }
            }
            transition={{ duration: 2, delay: 12 }}
        >

            <Desktop>
                <img src={zoomedNet} className={styles.zoomedNet} />
            </Desktop>
            <Mobile>
                <img src={mobileZoomedNet} className={styles.zoomedNet} />
            </Mobile>
            <Tablet>
                <img src={mobileZoomedNet} className={styles.zoomedNet} />
            </Tablet>
            <Desktop>
                <img src={zoomedNet} className={styles.zoomedNet} />
            </Desktop>




            <div className={styles.howDoIJoin1St3} style={{
                'marginLeft': '112px',
                'marginTop': '120px',
                'margin': '0px',
                'position': 'absolute',
                'top': '-103px',
                'left': '50px',
            }}>
                <span className={styles.hSpan}></span>
                <h3>03</h3>
                <p>
                    In order to become a Verified member you will
                    need to refer 5 people
                    to register their addresses in the ZUZ network.
                </p>
            </div>




        </motion.div >
    )
}


const ThreePeopleBox = (props) => {

    const { ref, inView, entry } = useInView({ trackVisibility: true, delay: 100 });

    const [fInView, setFInView] = useState(inView);

    useEffect(() => {
        setFInView(inView);
    }, [inView])


    return (
        <>

            <style>{`
                @keyframes commAnim { 
                    0%   {
                        opacity: 0;
                        transform: translateY(-70px);
                    }
            
                
                    100% {
                        opacity: 1;
                        transform: translateY(0px);
                    }
                }
            

            `}</style>
            <div className={`${styles.threePeopleBox} ${props.fInView ? styles.threePeopleBoxAnimClass:''}`}
            >

                <div className={styles.threeBoxes}>
                    <div className={styles.boxesContainer}>
                        <div
                            className={styles.bx1}
                            //style={{ animation: props.fInView ? `commAnim 1s 16s` : 'none' }}
                        >

                            <div
                                className={styles.bx1Inner}
                            >

                                <div className={styles.logo}>
                                    <img src={zuzLogoFilledNo} />
                                </div>
                                <div className={styles.description}>
                                    <p>
                                        You will be credited with <span style={{ color: '#2DDBF4' }}>1000 ZUZ</span> tokens <span style={{ color: '#2DDBF4' }}>+ 3%</span> of the ZUZ tokens you hold in your registered address.
                            </p>
                                </div>
                            </div>
                            <div className={styles.sil01}>
                                <Sil01></Sil01>
                            </div>
                        </div>

                        <div
                            className={styles.bx2}
                            //style={{ animation: props.fInView ? `commAnim 1s 17s` : 'none' }}
                        >
                            <div
                                className={styles.bx2Inner}
                            >
                                <div className={styles.logo}>
                                    <img src={zuzLogoFilledNo} />
                                </div>
                                <div className={styles.description}>
                                    <p>
                                        Your referrer will get 2% of the ZUZ held in his verified address.
                        </p>
                                </div>
                            </div>
                            <div className={styles.sil02}>
                                <Sil03></Sil03>
                            </div>
                        </div>

                        <div
                            className={styles.bx3}
                            //style={{ animation: props.fInView ? `commAnim 1s 18s` : 'none' }}
                        >

                            <div
                                className={styles.bx3Inner}
                            >
                                <div
                                    className={styles.logo}
                                >
                                    <img src={zuzLogoFilledNo} />
                                </div>
                                <div className={styles.description}>
                                    <p>
                                        A random verified member will get 1% of the ZUZ held in his verified address.
                            </p>
                                </div>
                            </div>
                            <div className={styles.sil03}>
                                <Sil02></Sil02>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}



export default Home

